// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Belt_Result from "../../../../../../../node_modules/rescript/lib/es6/belt_Result.js";
import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function fromString(value) {
  switch (value) {
    case "Fixed Pricing" :
        return /* FixedPricing */1;
    case "Non fixed pricing" :
        return /* NonFixedPricing */0;
    default:
      return ErrorUtils$Catalyst.raiseError("CreateTripFareStrategy.re", "Not a CreateTripFareStrategy", value);
  }
}

function toString(value) {
  if (value) {
    return "Fixed Pricing";
  } else {
    return "Non fixed pricing";
  }
}

var CreateTrip = {
  fromString: fromString,
  toString: toString
};

function fromString$1(value) {
  switch (value) {
    case "Fixed Pricing" :
        return /* FixedPricing */2;
    case "New Fixed Pricing" :
        return /* NewFixedPricing */1;
    case "Non Fixed Pricing" :
        return /* NonFixedPricing */0;
    default:
      return ErrorUtils$Catalyst.raiseError("EndTripFareStrategy.re", "Not a EndTripFareStrategy", value);
  }
}

function toString$1(value) {
  switch (value) {
    case /* NonFixedPricing */0 :
        return "Non Fixed Pricing";
    case /* NewFixedPricing */1 :
        return "New Fixed Pricing";
    case /* FixedPricing */2 :
        return "Fixed Pricing";
    
  }
}

function t_decode(json) {
  return Belt_Result.map(Decco.stringFromJson(json), fromString$1);
}

var EndTrip = {
  fromString: fromString$1,
  toString: toString$1,
  t_decode: t_decode
};

export {
  CreateTrip ,
  EndTrip ,
  
}
/* No side effect */
